import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Local de Publicação',
        path: '/biblioteca/biblocalpublicacao',
        name: 'biblocalpublicacao',
        component: () => import('@/views/biblioteca/biblocalpublicacao/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_LOCALDEPUBLICACAONOVO_MENU_1300800899],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Local de Publicação',
        path: '/biblioteca/biblocalpublicacao/cadastro/:id?',
        parent: 'biblocalpublicacao',
        name: 'biblocalpublicacao_create',
        component: () => import('@/views/biblioteca/biblocalpublicacao/InclusaoEdicao.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_LOCALDEPUBLICACAONOVO_MENU_1300800899],
        },
        goesToMenu: true,
    },
]
